import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-upload",
  "use": "foquz-icon-vue-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-upload\"><path d=\"M14 9v3.667A1.334 1.334 0 0112.667 14H3.333A1.334 1.334 0 012 12.667V9m9.333-3.667L8 2m0 0L4.667 5.333M8 2v8\" stroke=\"#679\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol